import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { resetAll } from "../actions/resetAll";

export interface PrecheckDetails {
  pan?: string;
  askEmail?: boolean;
  askMobile?: boolean;
  encryptedFolio?: string;
  encryptedEmail?: string;
  encryptedMobile?: string;
  dob?: string;
  investorName?: string;
}

export interface AuthState {
  isAuthenticated: boolean;
  mpinFailedAttempts: number;
  isVersionAllowed: boolean;
  precheckDetails: PrecheckDetails | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  mpinFailedAttempts: 0,
  isVersionAllowed: true,
  precheckDetails: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload;
    },
    increaseMpinFailedAttempts: (state) => {
      state.mpinFailedAttempts += 1;
    },
    resetMpinFailedAttempts: (state) => {
      state.mpinFailedAttempts = 0;
    },
    setIsVersionAllowed: (state, action: PayloadAction<boolean>) => {
      state.isVersionAllowed = action.payload;
    },
    setPrecheckDetails: (state, action: PayloadAction<PrecheckDetails | null>) => {
      state.precheckDetails = action.payload;
    },
    resetPrecheckDetails: (state) => {
      state.precheckDetails = null;
    },
  },
  extraReducers: (builder) =>
    builder.addCase(resetAll, () => ({
      isAuthenticated: false,
      mpinFailedAttempts: 0,
      isVersionAllowed: true,
      precheckDetails: null,
    })),
});

export const { reducer: authReducer, actions: authActions } = authSlice;

export default authSlice;
